import { create } from 'zustand';
import type { AdminStats } from '@/domain/model/AdminStats';
import { adminService } from '@/infrastructure/store/adminServiceInstance';
import { resolveErrorKey } from '@/infrastructure/util/error';

interface AdminStatsState {
  stats: AdminStats | null;
  isLoading: boolean;
  error: string | null;
}

interface AdminStatsActions {
  fetchStats: () => Promise<void>;
  clearError: () => void;
}

export const useAdminStatsStore = create<AdminStatsState & AdminStatsActions>((set) => ({
  stats: null,
  isLoading: false,
  error: null,

  fetchStats: async () => {
    set({ isLoading: true, error: null });
    try {
      const stats = await adminService.getStats();
      set({ stats, isLoading: false });
    } catch (e) {
      set({ isLoading: false, error: resolveErrorKey(e, 'admin.statsLoadFailed') });
    }
  },

  clearError: () => set({ error: null }),
}));
